import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import {
  AutoUpdateButtonComponent,
  AutoUpdateMessageComponent,
  AxisFitComponent,
  ComboBuilderComponent,
  ConditionalFormattingDialogComponent,
  ConditionalFormattingModalComponentFacade,
  EncodingBuilderHistogramsComponent,
  EncodingBuilderVegasComponent,
  FilterEncodingComponent,
  FilterModalService,
  FormatBuilderComponent,
  GroupedBuilderComponent,
  MarksPanelComponent,
  PivotBuilderComponent,
  RadialBuilderComponent,
  RankPanelComponent,
  StackedBuilderComponent,
  TextFormattingModalService,
  TotalsButtonComponent,
  TypeaheadAttrsListComponent,
} from '@mode/charts/feature-encoding';
import * as angular from 'angular';

export const DowngradedChartsFeatureEncodingModule = angular
  .module('downgraded-charts-feature-encoding', [])
  .directive('modeAutoUpdateButton', downgradeComponent({ component: AutoUpdateButtonComponent }))
  .directive('modeAutoUpdateMessage', downgradeComponent({ component: AutoUpdateMessageComponent }))
  .directive('modeAxisFit', downgradeComponent({ component: AxisFitComponent }))
  .directive('modeEncodingBuilderVegas', downgradeComponent({ component: EncodingBuilderVegasComponent }))
  .directive('modeEncodingBuilderHistogram', downgradeComponent({ component: EncodingBuilderHistogramsComponent }))
  .directive('modeFormatBuilder', downgradeComponent({ component: FormatBuilderComponent }))
  .directive('modeFilterEncoding', downgradeComponent({ component: FilterEncodingComponent }))
  .directive('modeMarksPanel', downgradeComponent({ component: MarksPanelComponent }))
  .directive('modeRankPanel', downgradeComponent({ component: RankPanelComponent }))
  .directive('modeComboBuilder', downgradeComponent({ component: ComboBuilderComponent }))
  .directive('modeGroupedBuilder', downgradeComponent({ component: GroupedBuilderComponent }))
  .directive('modeRadialBuilder', downgradeComponent({ component: RadialBuilderComponent }))
  .directive('modeStackedBuilder', downgradeComponent({ component: StackedBuilderComponent }))
  .directive('modePivotBuilder', downgradeComponent({ component: PivotBuilderComponent }))
  .directive('modeTotalsButton', downgradeComponent({ component: TotalsButtonComponent }))
  .directive('modeTypeaheadAttrsList', downgradeComponent({ component: TypeaheadAttrsListComponent }))
  .directive('modeConditionalFormattingDialog', downgradeComponent({ component: ConditionalFormattingDialogComponent }))
  .service('ConditionalFormattingModalComponentFacade', downgradeInjectable(ConditionalFormattingModalComponentFacade))
  .service('FilterModalService', downgradeInjectable(FilterModalService))
  .service('TextFormattingModalService', downgradeInjectable(TextFormattingModalService)).name;
